import axios from 'axios';
class Request {
  constructor(url, history) {
    this.fetch = axios.create({
      baseURL: url,
    });
    this.history = history;
  }

  getConfig = moreHeaders => {
    return {
      headers: {
        Authorization: `Bearer ${localStorage.customerJWT}`,
        ...moreHeaders,
      },
    };
  };

  expiredToken = error => {
    if (
      error?.response?.status === 401 &&
      error.response.data.message === 'Expired JWT Token'
    ) {
      this.history.push('/login');
      localStorage.removeItem('customerJWT');
    }
    throw error;
  };

  request = (method, url, data, options) => {
    const config = options || this.getConfig();
    if (method === 'get') {
      return this.fetch
        .request({ method, url, params: data, ...config })
        .catch(this.expiredToken);
    }
    return this.fetch
      .request({ method, url, data, ...config })
      .catch(this.expiredToken);
  };

  requestWOToken = (method, url, data, options) => {
    if (method === 'get') {
      return this.fetch.request({ method, url, params: data, ...options });
    }
    return this.fetch.request({ method, url, data, ...options });
  };

  getData = (endpoint, data) => this.request('get', endpoint, data);
  postData = (endpoint, data) => this.request('post', endpoint, data);
  putData = (endpoint, data) => this.request('put', endpoint, data);
  patchData = (endpoint, data) => this.request('patch', endpoint, data);
  deleteData = endpoint => this.request('delete', endpoint);

  postBlobData = (endpoint, data) =>
    this.request('post', endpoint, data, {
      ...this.getConfig(),
      responseType: 'blob',
    });

  postMultiPart = (endpoint, data) =>
    this.request('post', endpoint, data, {
      ...this.getConfig({ 'Content-Type': 'multipart/form-data' }),
    });

  postDataWOToken = (endpoint, data) =>
    this.requestWOToken('post', endpoint, data);

  getBlobData = (endpoint, data) =>
  this.request('get', endpoint, data, {
    ...this.getConfig(),
    responseType: 'blob',
  });
}

export { Request };
